import { gql } from "lib/apolloClient";
import { aiFragment } from "modules/CommonFragments";

export const createAIMessageMutation = gql`
  mutation createAiMessage($input: CreateAiMessageInput!) {
    ai {
      createAiMessage(input: $input) {
        isSuccess
        response {
          ...aiMessageItem
        }
      }
    }
  }
  ${aiFragment.aiMessage}
`;

export const createBulkAiMessagesMutation = gql`
  mutation createBulkAiMessages($input: CreateBulkAiMessagesInput!) {
    ai {
      createBulkAiMessages(input: $input) {
        isSuccess
        response {
          ...aiMessageItem
        }
      }
    }
  }
  ${aiFragment.aiMessage}
`;

export const deleteAIMessageMutation = gql`
  mutation deleteAiMessage($input: DeleteAiMessageInput!) {
    ai {
      deleteAiMessage(input: $input) {
        isSuccess
        warning
      }
    }
  }
`;
